import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IonBackButton, IonCheckbox, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonList, IonListHeader, IonTitle, IonToolbar, ModalController } from '@ionic/angular/standalone';
import { PageActionComponent, SuperStepItemComponent } from '@qid/super';
import {
  CreateCollectionTemplateDto,
  TemplateFieldSetterComponent,
  TemplateIdSetterComponent
} from "../../../collection-template";
import { Industry, IndustryService } from "../../../industry";
import { MasterTemplateService } from '../../components/services/master-template.service';
import { CreateMasterTemplateDto } from '../../dto/create-master-template.dto';
import { MasterTemplate } from '../../models/MasterTemplate';
import { SexyModule } from '@qid/sexy';

@Component({
  selector: 'app-create-master-template',
  templateUrl: './create-master-template.page.html',
  styleUrls: ['./create-master-template.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    IonHeader,
    IonToolbar,
    IonBackButton,
    IonTitle,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonInput,
    IonListHeader,
    IonCheckbox,
    SuperStepItemComponent,
    PageActionComponent
  ]
})
export class CreateMasterTemplatePage implements OnInit {
  public createMasterTemplateDto: CreateMasterTemplateDto =
    new CreateMasterTemplateDto();
  public industries: Industry[] = [];
  public masterTemplate: MasterTemplate;
  public collectionTemplate: CreateCollectionTemplateDto =
    new CreateCollectionTemplateDto();

  constructor(
    private industryService: IndustryService,
    private modalController: ModalController,
    private masterTemplateService: MasterTemplateService,
    private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit() {
    const id = this.activatedRoute.snapshot.paramMap.get('id');
    this.enableEditMode(id)
    this.fetchIndustries();
  }

  async fetchIndustries() {
    this.industries = await this.industryService.readAll(null);
  }


  onIndustryToggle(industryId: any) {
    const index = this.createMasterTemplateDto.industries.indexOf(industryId);
    if (index < 0) {
      this.createMasterTemplateDto.industries.push(industryId);
      return;
    }
    this.createMasterTemplateDto.industries.splice(index, 1);
  }

  public async openIdSetter() {
    const modal = await this.modalController.create({
      component: TemplateIdSetterComponent,
      componentProps: {
        defaultIds: this.collectionTemplate.acceptedIds,
      },
    });
    await modal.present();
    const modalRes = await modal.onDidDismiss();
    if (modalRes && modalRes.data?.acceptedIds) {
      this.collectionTemplate.acceptedIds = modalRes.data.acceptedIds;
    }
  }

  public async openFieldSetter() {
    const modal = await this.modalController.create({
      component: TemplateFieldSetterComponent,
      componentProps: {
        otherInfo: this.collectionTemplate.otherInfo,
      },
    });
    await modal.present();
    const modalRes = await modal.onDidDismiss();
    if (modalRes && modalRes.data?.otherInfo) {
      this.collectionTemplate.otherInfo = modalRes.data.otherInfo;
    }
  }


  private async enableEditMode(id: string = null) {
    if (id == null) {
      return;
    }

    const masterTemplate: MasterTemplate = await this.masterTemplateService.read(id)
    this.createMasterTemplateDto._id = masterTemplate._id
    //TODO : KINDLY FIX FOLLOWING "ANY" PATCH
    this.collectionTemplate = masterTemplate.template as any
    this.masterTemplate = masterTemplate

  }

  // isIndustrySelected(industry: Industry): boolean {
  // if (!this.masterTemplate) {
  //   return false
  // }
  // for (let ind of this.masterTemplate.industries) {
  //   if (ind._id == industry._id) {
  //     return true;
  //   }
  // }
  // return false
  // }
  isIndustrySelected() {

  }
}
